export interface WalkthroughStep {
  id: string;
  title: string;
  description: string;
  image?: string;
  alt: string;
}

export const WALKTHROUGH_STEPS: WalkthroughStep[] = [
  {
    id: 'welcome',
    title: 'Welcome to the Remote Desktop',
    description:
      'This is a simulated Windows 11 environment that behaves like a real machine. This short guide shows you how to navigate it.',
    image: '/tutorial/tutorialdesktop1.png',
    alt: 'Simulated Windows 11 desktop with taskbar and desktop icons',
  },
  {
    id: 'desktop-icons',
    title: 'Opening Applications',
    description:
      'Double click any icon on the desktop to open it, just like a real PC.',
    image: '/tutorial/tutorialdesktop2.png',
    alt: 'Desktop icons including Network Settings and Command Prompt',
  },
  {
    id: 'network-settings',
    title: 'Reviewing System Information',
    description:
      'Windows apps show diagnostic details. Read them carefully during your assessment.',
    image: '/tutorial/tutorialdesktop3.png',
    alt: 'Network and Internet settings window showing connection details',
  },
  {
    id: 'system-tray',
    title: 'The System Tray',
    description:
      'The icons at the bottom right show live system status. Click one to open its panel.',
    image: '/tutorial/tutorialdesktop4.png',
    alt: 'Windows taskbar system tray with Wi-Fi, volume, and clock',
  },
  {
    id: 'command-prompt',
    title: 'Using Command Prompt',
    description:
      'Click inside the black window, type a command, and press Enter to run it.',
    image: '/tutorial/tutorialdesktop5.png',
    alt: 'Command Prompt window with a blinking cursor at the prompt',
  },
  {
    id: 'logging',
    title: 'Your Actions Are Logged',
    description:
      'Every troubleshooting step you take here is recorded and scored as part of your final result.',
    alt: 'Assessment environment indicating that candidate actions are logged',
  },
];
